import { ReactNode } from 'react';
import { Tooltip } from '@client/new/components/basic';
import { rgb } from '@design-system/tokens';
import offerCover from '/static/images/offer-cover.png';
import * as styles from './OfferThumbnailTooltip.css';
import { Typography } from '@design-system/components/typography/typography';

const TooltipContent = () => (
  <div className={styles.content}>
    <div className={styles.text}>
      <Typography variant="body" size="medium">
        Offer thumbnail
      </Typography>
      <Typography variant="body" size="medium" fontWeight="normal">
        This will appear as a thumbnail image while presenting offer carousel on
        your channel landing page.
      </Typography>
      <div>
        <a
          href="https://www.canva.com/design/DAFvBSTqdB4/gLRCJOkyWpCvF4-BEtA53w/view?utm_content=DAFvBSTqdB4&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview#15"
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          Use Canva templates
        </a>
      </div>
    </div>
    <div className={styles.imageWrap}>
      <img src={offerCover} className={styles.image} alt="" />
    </div>
  </div>
);

export const OfferThumbnailTooltip = ({
  children,
}: {
  children: ReactNode;
}) => (
  <Tooltip
    title={<TooltipContent />}
    placement="right-start"
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: rgb('N-100'),
          color: rgb('W-100'),
          fontSize: '14px',
          fontFamily: 'inherit',
          borderRadius: '10px',
          width: '420px',
          maxWidth: 'unset',
          p: 0,
        },
      },
    }}
  >
    <span>{children}</span>
  </Tooltip>
);
